import React from 'react';
import { CubeTransparentIcon } from '@heroicons/react/24/solid';

export default function HeroSection2(props) {
  return (
    <section className="relative py-16 px-8 lg:px-12 h-full flex items-center">
      <div className="w-full">
        <div className="text-center lg:text-left">
          <a
            href="/"
            className="inline-block mb-8 text-white hover:text-white/80 transition-colors duration-200"
          >
            <CubeTransparentIcon className="inline-block w-10 h-10" />
          </a>
          
          <div className="mb-8">
            <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-4 leading-tight">
              {props.title}
            </h1>
            <p className="text-lg lg:text-xl text-white/90 max-w-lg lg:max-w-none mx-auto lg:mx-0">
              {props.subtitle}
            </p>
            {props.strapline && (
              <p className="text-base text-white/80 mt-3">
                {props.strapline}
              </p>
            )}
          </div>
          
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center lg:justify-start space-y-3 sm:space-y-0 sm:space-x-3 mb-6">
            <button className="btn-secondary px-6 py-3 text-base font-medium rounded-lg hover:transform hover:scale-105 transition-all duration-200">
              {props.button1Text || "Start Now"}
            </button>
          </div>
          
          <div className="text-white/80 text-sm">
            <span className="animate-pulse">⚡</span> No credit card required • 2-minute setup
          </div>
        </div>
      </div>
    </section>
  );
}
